import company from './company/company'
import discount from './discount/discount'
import employees from './employees/employees'
import dashboard from './dashboard/dashboard'
import refills from './refills/refills'
import localCompany from './localStorage/localCompany'
import noNominative from './accounts/noNominative'
import { login } from './login'
import authorization from './authorization/authorization'
import managementReports from './managementReports/managementReports'
import portal from './portal/portal'
import localActivity from './localStorage/localActivity'
import token from './token/token'
import password from './password/password'

export const REPOSITORY = {
  wsEmpresa: {
    authorization: { ...authorization },
    refills: { ...refills },
    discounts: { ...discount },
    employees: { ...employees },
    company: { ...company },
    accounts: { noNominative: { ...noNominative } },
    dashboard: { ...dashboard },
    login,
    reports: { ...managementReports },
    nuevoPortal: { ...portal },
    token: { ...token },
    password: { ...password },
  },
  local: { company: { ...localCompany }, activity: { ...localActivity } },
}
